import axios from "axios"
import * as api from "../api/soporte.api"

export default class SoporteService {
    getConfig = () => {
        const token = sessionStorage.getItem("token") || ""
        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    list = async ({ entity, status = "on", filters = {}, limit = 100, offset = 0, orderBy = "id", orderDir = "DESC" }) => {
        try {
            const response = await axios.post(
                api.list,
                { entity, status, filters, limit, offset, orderBy, orderDir },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al listar", error }
        }
    }

    getOne = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.getOne, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al consultar", error }
        }
    }

    create = async ({ entity, data }) => {
        try {
            const response = await axios.post(api.create, { entity, data }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al crear", error }
        }
    }

    update = async ({ entity, id, data, actor_user_id }) => {
        try {
            const response = await axios.post(
                api.update,
                { entity, id, data, actor_user_id },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al actualizar", error }
        }
    }

    remove = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.remove, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al eliminar", error }
        }
    }

    desactivate = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.desactivate, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al desactivar", error }
        }
    }

    activate = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.activate, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al activar", error }
        }
    }

    ticketAssign = async (payload) => {
        try {
            const response = await axios.post(api.ticketAssign, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al asignar ticket", error }
        }
    }

    ticketChangeStatus = async (payload) => {
        try {
            const response = await axios.post(api.ticketChangeStatus, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cambiar estado", error }
        }
    }

    ticketClose = async (payload) => {
        try {
            const response = await axios.post(api.ticketClose, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cerrar ticket", error }
        }
    }

    ticketReopen = async (payload) => {
        try {
            const response = await axios.post(api.ticketReopen, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al reabrir ticket", error }
        }
    }

    ticketEscalate = async (payload) => {
        try {
            const response = await axios.post(api.ticketEscalate, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al escalar ticket", error }
        }
    }

    listNotifications = async ({ limit = 25, only_unread = false } = {}) => {
        try {
            const response = await axios.post(
                api.notificationsList,
                { limit, only_unread },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar notificaciones", error }
        }
    }

    markNotificationRead = async ({ notification_id }) => {
        try {
            const response = await axios.post(
                api.notificationsRead,
                { notification_id },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al marcar notificación", error }
        }
    }

    markAllNotificationsRead = async () => {
        try {
            const response = await axios.post(
                api.notificationsReadAll,
                {},
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al marcar notificaciones", error }
        }
    }

    // ─── Parámetros de tickets ────────────────────────────────────────────
    getTicketModulos = async () => {
        try {
            const response = await axios.get(api.ticketModulos, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar módulos", error }
        }
    }

    getTicketEstados = async () => {
        try {
            const response = await axios.get(api.ticketEstados, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar estados", error }
        }
    }

    getTicketTiposContacto = async () => {
        try {
            const response = await axios.get(api.ticketTiposContacto, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar tipos de contacto", error }
        }
    }

    getTicketPrioridades = async () => {
        try {
            const response = await axios.get(api.ticketPrioridades, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar prioridades", error }
        }
    }

    getTicketSolicitudes = async () => {
        try {
            const response = await axios.get(api.ticketSolicitudes, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar solicitudes", error }
        }
    }

    getTicketEscalationUsers = async (grupoId = null) => {
        try {
            const url = grupoId
                ? `${api.ticketEscalationUsers}?grupo_id=${encodeURIComponent(grupoId)}`
                : api.ticketEscalationUsers
            const response = await axios.get(url, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar usuarios para escalado", error }
        }
    }

    getTicketClientesPagados = async () => {
        try {
            const response = await axios.get(api.ticketClientesPagados, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar clientes pagados", error }
        }
    }

    getTicketClientUsers = async (clienteId) => {
        try {
            const response = await axios.get(`${api.ticketClientesBase}/${clienteId}/usuarios`, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar solicitantes del cliente", error }
        }
    }

    getClientes = async () => {
        try {
            const response = await axios.get(api.clientes, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar clientes", error }
        }
    }

    getInventoryUsers = async () => {
        try {
            const response = await axios.get(api.inventoryUsers, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar usuarios de inventario", error }
        }
    }

    downloadInventoryTemplate = async () => {
        return axios.get(api.inventoryTemplate, {
            ...this.getConfig(),
            responseType: "blob"
        })
    }

    exportInventory = async () => {
        return axios.get(api.inventoryExport, {
            ...this.getConfig(),
            responseType: "blob"
        })
    }

    importInventory = async (file) => {
        const form = new FormData()
        form.append("upload", file)
        try {
            const response = await axios.post(api.inventoryImport, form, {
                ...this.getConfig(),
                headers: {
                    ...this.getConfig().headers,
                    "Content-Type": "multipart/form-data"
                }
            })
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al importar inventario", error }
        }
    }
}
